/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMenuDeep = createReactComponent("outline", "menu-deep", "IconMenuDeep", [["path", { "d": "M4 6h16", "key": "svg-0" }], ["path", { "d": "M7 12h13", "key": "svg-1" }], ["path", { "d": "M10 18h10", "key": "svg-2" }]]);

export { IconMenuDeep as default };
//# sourceMappingURL=IconMenuDeep.mjs.map
